import pageHeader from "../components/pageHeader/locals/ar.json";

export default {
  pageHeader,
};